import { chatActions } from "./slice";
import ChatRepository from "../../../../repositories/chat";
import { toast } from "react-toastify";
import i18next from "i18next";

const toastConfig = {
  position: "bottom-center",
  autoClose: 5000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

const chatRepository = new ChatRepository();

export const fetchFirstChats =
  (filter = {}, page = 1, pageSize = 500) =>
  async (dispatch) => {
    dispatch(chatActions.loadChats());
    try {
      const chats = await chatRepository.getAll(filter, page, pageSize);
      if (chats) {
        dispatch(
          chatActions.loadedChats({
            chats: chats.items,
            hasMore: chats.hasMore,
          })
        );
      }
    } catch (error) {
      toast.info(
        i18next.t("It seems something has gone wrong, please try again"),
        toastConfig
      );
    }
  };

  export const fetchMoreChats =
  (filter = {}, page = 1, pageSize = 500) =>
  async (dispatch) => {
    dispatch(chatActions.loadChats());
    try {
      const chats = await chatRepository.getAll(filter, page, pageSize);
      if (chats) {
        dispatch(
          chatActions.loadedMoreChats({
            chats: chats.items,
            hasMore: chats.hasMore,
          })
        );
      }
    } catch (error) {
      toast.info(
        i18next.t("It seems something has gone wrong, please try again"),
        toastConfig
      );
    }
  };

export const sendMessage = (payload) => async (dispatch) => {
  dispatch(chatActions.setSendMessage(true));

  const tempMessageId = `temp-${Date.now()}`;

  const tempMessage = {
    id: tempMessageId,
    message: payload.message,
    customer_user_id: payload.userId,
    createdAt: Date.now(),
    attachment: [],
    sending: true,
  };

  dispatch(chatActions.addMessage({ chatId: payload.chatId, message: tempMessage }));

  try {
    const response = await chatRepository.sendMessage(payload);
    if (response) {
      dispatch(chatActions.replaceMessage({ chatId: payload.chatId, tempId: tempMessageId, newMessage: response.data }));
    }
  } catch (error) {
    dispatch(chatActions.removeMessage({ chatId: payload.chatId, tempId: tempMessageId })); // Elimina el mensaje en caso de error

    toast.info(
      error.response?.data?.message ||
        i18next.t("It seems something has gone wrong, please try again"),
      toastConfig
    );
  } finally {
    dispatch(chatActions.setSendMessage(false));
  }
};

export const finalizeChat = (chatId, customerId) => async (dispatch) => {
  dispatch(chatActions.loadFinalizeChat());
  try {
    const response = await chatRepository.finalizeChat(chatId, customerId);
    if (response) {
      dispatch(chatActions.loadedFinalizeChat(response));
    }
  } catch (error) {
    toast.info(
      error.response?.data?.message ||
        i18next.t("It seems something has gone wrong, please try again"),
      toastConfig
    );
  }
};
